var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 32,
    viewBox: "0 0 39 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39 16C39 24.8205 31.6239 32 22.5522 32C19.2033 32 15.9815 31.0154 13.2261 29.2103C12.463 28.6769 12.2511 27.6923 12.8022 26.9128C13.3533 26.1744 14.3707 25.9692 15.1761 26.5026C17.338 27.9385 19.9239 28.7179 22.5522 28.7179C29.7587 28.7179 35.6087 23.0154 35.6087 16C35.6087 8.98462 29.7587 3.28205 22.5522 3.28205C15.5152 3.28205 9.75 8.73846 9.49565 15.5487L13.438 11.6923C14.1163 11.0359 15.1761 11.0359 15.8543 11.6923C16.5326 12.3487 16.5326 13.3744 15.8543 14.0308L9.36848 20.3077C9.02935 20.6359 8.60543 20.8 8.18152 20.8C7.71522 20.8 7.2913 20.6359 6.99457 20.3077L0.508696 13.9897C-0.169565 13.3333 -0.169565 12.3077 0.508696 11.6513C1.18696 10.9949 2.24674 10.9949 2.925 11.6513L6.14674 14.8103C6.74022 6.5641 13.862 0 22.5522 0C31.6239 0 39 7.17949 39 16ZM22.4674 6.68718C21.5348 6.68718 20.7717 7.42564 20.7717 8.32821V16C20.7717 16.4513 20.9837 16.8615 21.3228 17.1487L24.9685 20.6769C25.3076 21.0051 25.7315 21.1692 26.1978 21.1692C26.6217 21.1692 27.088 21.0051 27.3848 20.6769C28.063 20.0205 28.0207 18.9949 27.3424 18.3385L24.163 15.3026V8.32821C24.163 7.42564 23.4 6.68718 22.4674 6.68718Z",
    fill: "#656565"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTime);
export default __webpack_public_path__ + "static/media/Time.541ed1a2f12635a5376647b3fc6a6ae2.svg";
export { ForwardRef as ReactComponent };